import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import {
    AppStateFacade,
    Setting,
} from '@app-state';
import { UiModalComponent } from '@components';
import { ModalResultType } from '@models';

@Component({
    templateUrl: './deactivate-offline.modal.html',
    styleUrls: ['./deactivate-offline.modal.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class DeactivateOfflineModalComponent
    extends UiModalComponent<number | undefined>
    implements OnInit {

    public serviceUrl?: string;

    private _appState = this._injector.get<AppStateFacade>(AppStateFacade);

    ngOnInit() {
        this.serviceUrl = this._appState.settings.get(Setting.serviceUrl);
    }

    public generate() {
        this.customEvent.emit({
            type: ModalResultType.Generic,
        });
    }

    public onClose() {
        this._dialogRef.close({
            type: ModalResultType.Failed,
            data: this.context.data,
        });
    }
}
